import { render, staticRenderFns } from "./ThemedCard.vue?vue&type=template&id=531a4aed&scoped=true"
import script from "./ThemedCard.vue?vue&type=script&lang=ts"
export * from "./ThemedCard.vue?vue&type=script&lang=ts"
import style0 from "./ThemedCard.vue?vue&type=style&index=0&id=531a4aed&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531a4aed",
  null
  
)

export default component.exports